import { toast } from 'sonner';
import { RUNTIME_BACKEND_URL } from './backendUrl';

export const postJson = async (url, body, token) => {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const r = await fetch(`${RUNTIME_BACKEND_URL}${url}`, { method: 'POST', headers, body: JSON.stringify(body) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.detail || 'İşlem başarısız');
  return d;
};

// Giriş hatası "e-posta onaylanmamış" ise tekrar gönder seçeneği sunar
export const showLoginError = (err, apiBase, email) => {
  if (err.message !== 'EMAIL_NOT_VERIFIED') {
    toast.error(err.message);
    return;
  }
  toast.error('E-posta adresiniz henüz onaylanmamış. Gelen kutunuzu (ve spam klasörünü) kontrol edin.', {
    duration: 10000,
    action: {
      label: 'Tekrar gönder',
      onClick: () => postJson(`${apiBase}/resend-verification`, { email })
        .then(() => toast.success('Onay e-postası tekrar gönderildi'))
        .catch(e => toast.error(e.message)),
    },
  });
};
